export const ADD_TOAST = '[Toasts] add toast';
export const DISPOSE_TOAST = '[Toasts] dispose toast';
